/** @typedef {import('../../types/models').Settlement} Settlement */

import { useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';

import { fetchSettlements } from '../../api';
import { queryClient } from '../../config';
import { generatedDates, handleQueryError } from '../../utils';

/** @returns {{ recentSettlements: Settlement[], settlements: Settlement[], isFetching: boolean, isLoading: boolean, isFetchingNextPage: boolean, fetchNextPage: Function, hasNextPage: boolean, searchQuery: string, setSearchQuery: Function, isRefetching: boolean, setStatus: Function, status: string, filterByDate: Function, refetch: Function }} */
const useFetchSettlements = () => {
  const [settlements, setSettlements] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState('');
  const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
  let recentSettlements = [];
  const {
    isFetching,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isError,
    data,
    refetch,
    isRefetching,
    error
  } = useInfiniteQuery(
    ['allSettlements'],
    ({ pageParam }) => {
      return fetchSettlements({ offset: pageParam, searchQuery, status, dateFilter });
    },
    {
      getNextPageParam: (lastPage) => {
        const hasNext = lastPage.meta?.hasNext;
        const lastSettlement = lastPage && lastPage.data[lastPage.data.length - 1];
        return hasNext ? lastSettlement && lastSettlement.id : undefined;
      }
    }
  );
  if (isError) {
    handleQueryError(error, 'settlements');
  }
  useEffect(() => {
    if (data && data.pages) {
      let aggregatedSettlements = [];
      data.pages.map(({ data: settlementsList }) => {
        aggregatedSettlements = [...aggregatedSettlements, ...settlementsList];
      });
      setSettlements(aggregatedSettlements);
    }
  }, [data]);
  recentSettlements = settlements.slice(0, 3);

  useEffect(() => {
    setSettlements([]);
    queryClient.removeQueries('allSettlements', { exact: true });
    refetch({ refetchPage: (page, index) => index === 0, resetQueries: true });
  }, [searchQuery, status, dateFilter]);
  const filterByDate = (dateType) => {
    if (dateType) {
      setDateFilter({ from: generatedDates[dateType](), to: generatedDates.now() });
    } else {
      setDateFilter({ from: null, to: null });
    }
  };

  return {
    recentSettlements,
    settlements,
    isFetching,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    searchQuery,
    setSearchQuery,
    isRefetching,
    setStatus,
    status,
    filterByDate,
    refetch
  };
};

export { useFetchSettlements };
